import { type ProductOrderSummaryItemDto } from 'entities/ReportSavingsSummary';
import { type ReportWidgetItem } from 'widgets/ComposableReportWidget';

export const mapProductOrdersToWidgetItems = (
    orderItems: ProductOrderSummaryItemDto[],
    fromMissedSavings: boolean,
): ReportWidgetItem[] =>
    orderItems
        .filter((orderItem) =>
            fromMissedSavings
                ? (orderItem.totalMissed ?? 0) > 0
                : orderItem.totalSaved > 0,
        )
        .map((orderItem, index): ReportWidgetItem => {
            const submittedDate = new Date(orderItem.submittedAt);
            const dateLabel = new Intl.DateTimeFormat(undefined, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            }).format(submittedDate);

            const savingsValue = fromMissedSavings
                ? orderItem.totalMissed ?? 0
                : orderItem.totalSaved;
            const avgSupplierTotal = fromMissedSavings
                ? orderItem.totalPaid - savingsValue
                : orderItem.baselinePrice * orderItem.quantity;

            return {
                id: `${orderItem.order.orderId}-${index}`,
                label: orderItem.order.orderNumber,
                primaryValue: savingsValue,
                secondaryValues: {
                    date: dateLabel,
                    orderNumber: orderItem.order.orderNumber,
                    propertyName: orderItem.propertyName,
                    suppliers: orderItem.suppliers.join(', '),
                    quantity: orderItem.quantity,
                    pricePaid: orderItem.totalPaid,
                    avgSupplierPrice: avgSupplierTotal,
                    savings: savingsValue,
                    percentSaved: orderItem.percentSaved,
                },
                meta: { orderId: orderItem.order.orderId },
            };
        });
